import { axios } from './apiClient';
import {
  UploadFileParams,
  DeleteFileParams,
  FileResponse,
  PresignedUrlResponse,
  SubmitFileParams
} from '../types/files';

export const submitFile = async (params: SubmitFileParams): Promise<FileResponse> => {
  const { transactionId, token, fileId } = params;
  const maxAttempts = 10;
  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  let lastError: unknown;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const response = await axios.post<FileResponse>(
        `/files/${transactionId}/submit`,
        { fileId },
        { headers: { Authorization: token } }
      );
      return response.data;
    } catch (error) {
      lastError = error;
      if (error) {
        if (attempt === maxAttempts) {
          throw new Error('Max retry attempts reached.');
        }
        console.warn(`Attempt ${attempt} failed with status 412. Retrying in 5 seconds...`);
        await delay(5000);
      } else {
        throw error;
      }
    }
  }
  throw lastError;
};

export const createPresignedUrl = async (params: UploadFileParams): Promise<PresignedUrlResponse> => {
  const { transactionId, token, files } = params;
  const file = files[0];
  const response = await axios.post<PresignedUrlResponse>(
    `/files/${transactionId}/url`,
    { file: { filename: file.filename, mimeType: file.mimeType } },
    { headers: { Authorization: token } }
  );
  return response.data;
};

export const uploadDocumentToUrl = (file: any, url: string) => {
  return axios.put(url, file).then((response: any) => {
    return response.data;
  });
};

export const removeFile = async (params: DeleteFileParams): Promise<FileResponse> => {
  const { transactionId, token, fileId } = params;
  const response = await axios.delete<FileResponse>(`/files/${transactionId}/${fileId}`, {
    headers: {
      Authorization: token
    }
  });
  return response.data;
};
